@if (rootTypeLoading()) {
  <div class="text-gray-500">{{ 'propertyFormat.loading' | translate }}</div>
} @else if (rootTypeError()) {
  <div class="text-red-500">
    {{ 'propertyFormat.errorLoadingData' | translate: { error: rootTypeErrorString() } }}
  </div>
} @else {
  <div class="space-y-4">
    <div class="border border-gray-200 rounded-lg shadow-md bg-white">
      <button
        type="button"
        (click)="toggleExpanded()"
        class="w-full bg-white px-4 py-3 flex items-center justify-between hover:bg-gray-100 transition-colors rounded-t-lg">
        <span class="text-sm font-medium text-gray-700">{{ pageTitle() }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          class="w-5 h-5 text-gray-600 transform transition-transform duration-200"
          [class.rotate-180]="isExpanded()">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      @if (isExpanded()) {
        <div class="border-t border-gray-200">
          @if (hasFormatOptions()) {
            <div class="p-4">
              <cmi-property-format-form
                [property]="sourceProperty()!"
                [initialFormatString]="formatSuffix() ?? undefined"
                [isApplying]="isApplying()"
                (applyFormat)="onApplyFormat($event)" />
            </div>
          }
          <div class="space-y-4">
            <cmi-content-control-editor
              [id]="contentControlId()"
              [refreshTrigger]="refreshTriggerSignal()" />
          </div>
        </div>
      }
    </div>
  </div>
}
